import { useRef, useEffect, ReactElement } from "react";
import { createPortal } from "react-dom";
import "./modal.scss";

interface Props {
  open: boolean;
  content: ReactElement;
  closeHanlder: () => void;
  className?: string;
  headerControls?: ReactElement;
  footerControls?: ReactElement;
  closeOnOverlayClick?: boolean;
}

export function Modal(props: Props) {
  const {
    open,
    content,
    className,
    headerControls,
    footerControls,
    closeHanlder,
    closeOnOverlayClick = false,
  } = props;
  return open ? (
    <PortalRoot>
      <div className="overlay" onClick={closeOnOverlayClick ? closeHanlder : undefined}>
        <div
          className={
            ["modal-root", className && className].join(" ") +
            " md:tw-max-h-[80vh] xl:tw-max-h-[90vh] "
          }
        >
          <div className="content">
            {headerControls && <header className="header-controls">{headerControls}</header>}
            <main className="body tw-relative tw-h-fit md:tw-max-h-[70vh] xl:tw-max-h-[80vh] tw-overflow-y-scroll ">
              {content}
            </main>
            {footerControls && <footer className="footer-controls">{footerControls}</footer>}
          </div>
        </div>
      </div>
    </PortalRoot>
  ) : null;
}

export function PortalRoot({ children }: { children: ReactElement }) {
  const elem = useRef(document.createElement("div"));

  useEffect(() => {
    const current = elem.current;
    document.body.appendChild(current);
    return () => {
      document.body.removeChild(current);
    };
  }, []);

  return createPortal(children, elem.current);
}
